export enum FilterOperatorType {
  eq = 'eq',
  ne = 'ne',
  gt = 'gt',
  ge = 'ge',
  lt = 'lt',
  le = 'le',
  in = 'in',
  notIn = 'notIn',
  contains = 'contains',
  notContains = 'notContains',
  startswith = 'startswith',
  endswith = 'endswith',
  today = 'today',
  yesterday = 'yesterday',
  onOrBeforeToday = 'onOrBeforeToday',
  onOrAfterToday = 'onOrAfterToday',
  thisWeek = 'thisWeek',
  thisMonth = 'thisMonth',
  thisYear = 'thisYear',
  lastWeek = 'lastWeek',
  lastMonth = 'lastMonth',
  lastYear = 'lastYear',
  isEmpty = 'isEmpty',
  isNotEmpty = 'isNotEmpty',
  isCurrentlyActive = 'isCurrentlyActive',
  isNotCurrentlyActive = 'isNotCurrentlyActive',
  activeOn = 'activeOn',
  startsBefore = 'startsBefore',
  startsAfter = 'startsAfter',
  endsBefore = 'endsBefore',
  endsAfter = 'endsAfter',
}
